import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import HomeCogGraphic from './HomeCogGraphic';

const HomeHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                {/* <div className="lp-badge lp-badge--up" data-lp-reveal><span />AI-powered transaction readiness</div> */}
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60" style={{ fontSize: '45px' }}>The UK's leading low-cost platform for automated SME transaction readiness and diligence</h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120" style={{ fontSize: '18px' }}>
                    70% of SME investment/exit transactions historically not diligenced due to cost.
                    <br /> Changing a process that used to take weeks and cost tens of thousands, into one which takes you days and costs from £100 pa.
                    <br /> Quicker deals. Less cost. Higher valuations. Saving you time and hassle.
                </p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <Link className="lp-btn lp-btn--primary lp-btn--stacked" to={ROUTES.REGISTER}>
                        <span className="lp-btn-title">Get started free</span>
                        <span className="lp-btn-sub">No credit card required</span>
                    </Link>
                </div>
                {/* <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#FC7785', display: 'inline-block', flex: 'none' }} />
                    Trusted by 50+ investors, advisors, and growing companies · No credit card required
                </div> */}
            </div>

            <div className="lp-hero-art">
                <HomeCogGraphic />
            </div>
        </div>
    </section>
);

export default HomeHeroSection;
